import { render } from "./News.vue?vue&type=template&id=00c97a74"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&id=00c97a74&lang=scss"
script.render = render

export default script